import DashboardLayout from '../../core/Layout/Layout.jsx';
import { RumDashboardMain } from './RumDashboardMain.jsx';
import './RumDashboardMain.css';

const DashboardRUMView = () => (
    <DashboardLayout>
        <RumDashboardMain></RumDashboardMain>
    </DashboardLayout>
);

export default DashboardRUMView;
